module.exports = __webpack_public_path__ + "img/publication-5.b7d9f699.jpg";